import { render, staticRenderFns } from "./invitedDatails.vue?vue&type=template&id=c49ca93c&scoped=true"
import script from "./invitedDatails.vue?vue&type=script&lang=js"
export * from "./invitedDatails.vue?vue&type=script&lang=js"
import style0 from "./invitedDatails.vue?vue&type=style&index=0&id=c49ca93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49ca93c",
  null
  
)

export default component.exports